// extracted by mini-css-extract-plugin
module.exports = {"container":"BadgeTag_container__2w5v5","noMargins":"BadgeTag_noMargins__1doMu","compact":"BadgeTag_compact__31J-J"};